import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getPO(params) {
	return clientSupplier.get("api-supplier/po/data", {
		params: params,
	});
}

function exportPO(params) {
	return clientSupplier.get("api-supplier/po/export", {
		params: params,
	});
}

function detailPO(params) {
	return clientSupplier.get("api-supplier/po/detail", {
		params: {
			po_code : params
		},
	});
}

function getSupplierProducts (params) {
	return clientSupplier.get("api/options/product-by-supplier", {
		params: params,
	});
}

function createPO (params) {
	return clientSupplier.post("api-supplier/po/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approvePO (params) {
	return clientSupplier.post("api-supplier/po/approve", qs.stringify({
		po_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectPO (params) {
	return clientSupplier.post("api-supplier/po/reject", qs.stringify({
		po_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deletePO (params) {
	return clientSupplier.post("api-supplier/po/delete", qs.stringify({
		po_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function POforPDO(params) {
	return clientSupplier.get("api-supplier/po/dataforPDO", {
		params: params,
	});
}

export default {
	getPO,
	exportPO,
	detailPO,
	getSupplierProducts,
	createPO,
	approvePO,
	rejectPO,
	deletePO,
	POforPDO
};